import { render, staticRenderFns } from "./xwsj_kg.vue?vue&type=template&id=2f74bca8&scoped=true&"
import script from "./xwsj_kg.vue?vue&type=script&lang=js&"
export * from "./xwsj_kg.vue?vue&type=script&lang=js&"
import style0 from "./xwsj_kg.vue?vue&type=style&index=0&id=2f74bca8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f74bca8",
  null
  
)

export default component.exports